import { render, staticRenderFns } from "./setPageStatus.vue?vue&type=template&id=66877477&scoped=true"
import script from "./setPageStatus.vue?vue&type=script&lang=js"
export * from "./setPageStatus.vue?vue&type=script&lang=js"
import style0 from "./setPageStatus.vue?vue&type=style&index=0&id=66877477&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66877477",
  null
  
)

export default component.exports